import { render, staticRenderFns } from "./QuoteAwaitingClient.vue?vue&type=template&id=7478f001&"
import script from "./QuoteAwaitingClient.vue?vue&type=script&lang=js&"
export * from "./QuoteAwaitingClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7478f001')) {
      api.createRecord('7478f001', component.options)
    } else {
      api.reload('7478f001', component.options)
    }
    module.hot.accept("./QuoteAwaitingClient.vue?vue&type=template&id=7478f001&", function () {
      api.rerender('7478f001', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/reservationAdministration/QuoteAwaitingClient.vue"
export default component.exports